import { useState } from "react";
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
import { Column, Row, TitleSection } from "components/styles";
import { Container, ContainerTooltip } from "./styles";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import useDataRelatedToForm from "./utils/hooks/useDataRelatedToForm";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import useEnvironmentList from "./utils/hooks/useEnvironmentList";
import useForm from "./utils/hooks/useForm";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import TooltipButton from "components/TooltipButton/TooltipButton";

const DialogUpdateMassiveAndPendingAcadReinforce = ({
    loadingRequest, toastMessageSuccess,
    dialogShow, acadReinforceId, fillAcadReinforceList
}) => {
    const form = useForm({
        loadingRequest,
        toastMessageSuccess,
        acadReinforceId,
        fillAcadReinforceList,
        dialogShow
    });
    const {
        campusDetailId, environmentTypeId,
        quantityVacancy, date, timeStart, timeEnd,
        environment
    } = form.value;
    //#region States
    const [timeoutIdFieldForTriggerFillEnvironments, setTimeoutIdFieldForTriggerFillEnvironments] = useState(null);
    //#endregion
    //#region Functions
    const changeCampus = value => {
        form.change("campusDetailId", value);
        environmentList.fill();
    }
    const changeEnvironmentType = value => {
        form.change("environmentTypeId", value);
        environmentList.fill();
    }
    const changeQuantityVacancy = value => {
        clearTimeout(timeoutIdFieldForTriggerFillEnvironments);
        form.change("quantityVacancy", value);
        const timeoutId = setTimeout(() => environmentList.fill(), 500);
        setTimeoutIdFieldForTriggerFillEnvironments(timeoutId);
    }
    const changeDate = value => {
        form.change("date", value);
        environmentList.fill();
    }
    const changeTimeStart = value => {
        form.change("timeStart", value);
        environmentList.fill();
    }
    const changeTimeEnd = value => {
        form.change("timeEnd", value);
        environmentList.fill();
    }
    const changeEnvironment = value => {
        const environmentFound = environmentList.value.find(environment => environment.id === value);
        form.change("environment", environmentFound);
    }
    //#endregion
    //#region Custom Hooks
    const { 
        campusDetailList, 
        environmentTypeList 
    } = useDataRelatedToForm();
    const environmentList = useEnvironmentList({
        loadingRequest,
        form
    });
    //#endregion
    return (
        <DialogAlert 
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}>
            <Container className="custom-scrollbar secodary">
                <TitleSection>Editar refuerzo masivo</TitleSection>
                <Column marginTop="10px">
                    <Row justifyContent="flex-start">
                        <CustomSelect
                            label="Campus"
                            optionsProps={getOptionsToCustomSelect(campusDetailList, { id: "id", text: "name" })}
                            value={campusDetailId}
                            onChange={changeCampus}
                            defaultOptionText="Elige un campus"
                            required/>
                        <CustomSelect
                            label="Tipo de ambiente"
                            optionsProps={getOptionsToCustomSelect(
                                environmentTypeList, { 
                                    id: "id", text: "name" 
                                })}
                            value={environmentTypeId}
                            onChange={changeEnvironmentType}
                            defaultOptionText="Elige un tipo de ambiente"
                            required/>
                        <CustomTextInput
                            label="Vacantes"
                            value={quantityVacancy}
                            onChange={changeQuantityVacancy}
                            maxLength={5}
                            onKeyPress={handlerKeyPressOnlyNumbers}
                            placeholder="Vacantes"
                            tooltipButton={ 
                                <ContainerTooltip marginLeft="3px">
                                    <TooltipButton 
                                        message="Máx. 90 personas en la mayoría de ambientes"
                                        tooltipProps={{
                                            width: "165px",
                                            after: {
                                                x: "-335%"
                                            }
                                        }}/>
                                </ContainerTooltip>}
                            minWidth="145px"
                            width="145px"/>
                    </Row>
                    <Row width="unset">
                        <CustomDatePicker
                            label="Fecha"
                            value={date}
                            onChange={changeDate}
                            required/>
                        <Column width="unset">
                            <Row width="unset">
                                <CustomTime
                                    label="Hora de inicio"
                                    onChange={changeTimeStart}
                                    value={timeStart}/>
                                <CustomTime
                                    label="Hora de finalización"
                                    onChange={changeTimeEnd}
                                    value={timeEnd}/>
                            </Row>
                            <ErrorMessage
                                error={timeEnd <= timeStart}
                                text="La hora de finalización debe ser mayor a la de inicio"/>
                        </Column>
                    </Row>
                    <Row justifyContent="flex-start">
                        <CustomSelect
                            label="Ambiente"
                            defaultOptionText="Elige un ambiente"
                            optionsProps={
                                getOptionsToCustomSelect(
                                    environmentList.value, { 
                                    id: "id", text: "environmentCode" 
                                })}
                            value={environment.id}
                            onChange={changeEnvironment}
                            disabled={environmentList.value.length === 0}
                            required/>
                        <CustomTextInput
                            label="Piso"
                            placeholder="Piso"
                            value={environment.floor}
                            minWidth="180px"
                            width="180px"
                            disabled/>
                        <CustomTextInput
                            label="Capacidad"
                            placeholder="Capacidad"
                            value={environment.capacity}
                            minWidth="175px"
                            width="175px"
                            disabled/>
                    </Row>
                    <CustomTextInput
                        label="Dirección"
                        placeholder="Dirección"
                        value={environment.address}
                        width="100%"
                        disabled/>
                </Column>
                <ErrorMessage
                    text="No se han encontrado ambientes disponibles con estos datos"
                    error={environmentList.value.length === 0}/>
                <Row 
                    marginTop="15px" 
                    marginBottom="10px" 
                    justifyContent="center">
                    <CustomButton
                        variant="secondary"
                        text="Cancelar"
                        onClick={() => dialogShow.set(false)}/>
                    <CustomButton
                        text="Actualizar"
                        onClick={form.update}
                        disabled={!form.isValid}/>
                </Row>
            </Container>
        </DialogAlert>
    );
}

export default DialogUpdateMassiveAndPendingAcadReinforce;